import { motion } from "framer-motion";
import { EASE } from "@/lib/scroll";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

const lineVariants = {
  hidden: { y: "108%" },
  show: { y: "0%", transition: { duration: 1.1, ease: EASE } },
};

export const MaskText = ({ lines, delay = 0, onLoad = false, className = "" }) => {
  const container = { hidden: {}, show: { transition: { staggerChildren: 0.09, delayChildren: delay } } };
  const trigger = onLoad ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.15 } };
  return (
    <motion.span className={`block ${className}`} initial="hidden" variants={container} {...trigger}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span className="block will-change-transform" variants={lineVariants}>
            {l}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`flex items-center gap-3 font-mono text-xs uppercase tracking-[0.28em] text-champagne ${className}`}>
    <span className="h-px w-8 bg-gold" />
    {children}
  </p>
);
